export default {
  title: "Budget",
  description: "Verwalten Sie Ihr Hochzeitsbudget",
  totalBudget: "Gesamtbudget",
  totalSpent: "Gesamtausgaben",
  remaining: "Verbleibend",
  toPay: "Zu zahlen",
  exceeded: "Überschritten",
  noCategories: "Keine Kategorien konfiguriert",
  percentage: "Prozentsatz",
  category: "Kategorie",
  addExpense: "Ausgabe hinzufügen",
  editExpense: "Ausgabe bearbeiten",
  deleteExpense: "Ausgabe löschen",
  expenseTitle: "Ausgabentitel",
  amount: "Betrag",
  date: "Datum",
  vendor: "Dienstleister",
  notes: "Notizen",
  paid: "Bezahlt",
  pending: "Ausstehend",

  noExpenses: {
    title: "Keine Ausgaben gefunden",
    description: "Beginnen Sie mit dem Hinzufügen Ihrer ersten Ausgabe"
  },
  monthlyExpenses: "Monatliche Ausgaben",
  sharing: {
    recipientEmail: "Empfänger-E-Mail",
    emailPlaceholder: "beispiel@email.com",
    recipientName: "Empfängername",
    namePlaceholder: "Name",
    message: "Nachricht",
    messagePlaceholder: "Ihre Nachricht...",
    send: "Senden",
    cancel: "Abbrechen",
    title: "Budget teilen"
  },
  addFirstExpense: "Fügen Sie Ihre erste Ausgabe hinzu",
  budgetOverview: "Budgetübersicht",
  expenseDetails: "Ausgabendetails",
  save: "Speichern",
  cancel: "Abbrechen",
  delete: "Löschen",
  edit: "Bearbeiten",
  view: "Ansehen",
  confirmDelete: "Sind Sie sicher, dass Sie diese Ausgabe löschen möchten?",
  expenseAdded: "Ausgabe erfolgreich hinzugefügt",
  expenseUpdated: "Ausgabe erfolgreich aktualisiert",
  expenseDeleted: "Ausgabe erfolgreich gelöscht",
  budgetExceeded: "Budget überschritten",
  budgetWarning: "Budgetwarnung",
  budgetOnTrack: "Budget im Plan",
  setBudget: "Budget festlegen",
  editBudget: "Budget bearbeiten",
  budgetAmount: "Budgetbetrag",
  budgetSet: "Budget erfolgreich festgelegt",
  budgetUpdated: "Budget erfolgreich aktualisiert",
  currency: "Währung",
  estimatedCost: "Geschätzte Kosten",
  actualCost: "Tatsächliche Kosten",
  difference: "Differenz",
  overBudget: "Über Budget",
  underBudget: "Unter Budget",
  onBudget: "Im Budget",
  budgetAnalysis: "Budgetanalyse",
  categoryBreakdown: "Aufschlüsselung nach Kategorie",
  monthlySpending: "Monatliche Ausgaben",
  upcomingExpenses: "Kommende Ausgaben",
  recentExpenses: "Kürzliche Ausgaben",
  budgetSummary: "Budgetzusammenfassung",
  totalAllocated: "Insgesamt zugewiesen",
  totalUnallocated: "Insgesamt nicht zugewiesen",
  allocationPercentage: "Zuweisungsprozentsatz",
  spendingTrend: "Ausgabentrend",
  averageExpense: "Durchschnittliche Ausgabe",
  largestExpense: "Größte Ausgabe",
  smallestExpense: "Kleinste Ausgabe",
  expenseCount: "Anzahl der Ausgaben",
  budgetUtilization: "Budgetauslastung",
  projectedTotal: "Projizierte Gesamtsumme",
  savingsGoal: "Sparziel",
  emergencyFund: "Notfallfonds",
  contingencyPercentage: "Notfallprozentsatz",
  recommendedContingency: "Empfohlener Notfallfonds",
  import: "Importieren",
  exportToCsv: "Als CSV exportieren",
  exportToPdf: "Als PDF exportieren",
  importFromCsv: "Aus CSV importieren",
  downloadTemplate: "Vorlage herunterladen",
  budgetTemplate: "Budgetvorlage",
  customCategory: "Benutzerdefinierte Kategorie",
  addCategory: "Kategorie hinzufügen",
  categoryName: "Kategoriename",
  categoryBudget: "Kategoriebudget",
  categoryAdded: "Kategorie erfolgreich hinzugefügt",
  categoryUpdated: "Kategorie erfolgreich aktualisiert",
  categoryDeleted: "Kategorie erfolgreich gelöscht",
  duplicateCategory: "Kategorie existiert bereits",
  search: "Ausgaben suchen",
  filter: "Filtern",
  filterByCategory: "Nach Kategorie filtern",
  filterByStatus: "Nach Status filtern",
  filterByDate: "Nach Datum filtern",
  sortBy: "Sortieren nach",
  sortByDate: "Nach Datum sortieren",
  sortByAmount: "Nach Betrag sortieren",
  sortByCategory: "Nach Kategorie sortieren",
  ascending: "Aufsteigend",
  descending: "Absteigend",
  clearFilters: "Filter löschen",
  noFilterResults: "Keine Ausgaben entsprechen Ihren Filtern",
  showAll: "Alle anzeigen",
  showPaid: "Bezahlte anzeigen",
  showPending: "Ausstehende anzeigen",
  thisMonth: "Diesen Monat",
  lastMonth: "Letzten Monat",
  thisYear: "Dieses Jahr",
  customRange: "Benutzerdefinierter Zeitraum",
  from: "Von",
  to: "Bis",
  apply: "Anwenden",
  reset: "Zurücksetzen",
  expenseCreated: "Ausgabe erfolgreich erstellt",
  totalExpenses: "{{count}} Ausgaben",
  estimateBudget: "Budget schätzen",
  estimateBudgetShort: "Schätzen",
  newExpense: "Neue Ausgabe",
  add: "Hinzufügen",
  overview: "Übersicht",
  distribution: "Verteilung",
  expensesList: "Ausgabenliste",
  exportPdf: "PDF exportieren",
  budgetUsed: "Budget verbraucht",
  loading: "Laden...",
  total: "Gesamt",
  confirmDeleteExpense: "Sind Sie sicher, dass Sie diese Ausgabe löschen möchten?",
  noExpensesText: "Keine Ausgaben",
  importExpenses: "Ausgaben importieren",
  exportExpenses: "Ausgaben exportieren",
  budgetDetails: "Budgetdetails",
  budgetHistory: "Budgetverlauf",
  budgetAnalytics: "Budgetanalysen",
  budgetSettings: "Budgeteinstellungen",
  spent: "Ausgegeben",

  categories: {
    venue: "Veranstaltungsort",
    catering: "Catering",
    flowers: "Blumen",
    photography: "Fotografie",
    music: "Musik",
    attire: "Kleidung",
    rings: "Ringe",
    transportation: "Transport",
    decoration: "Dekoration",
    invitations: "Einladungen",
    gifts: "Geschenke",
    honeymoon: "Flitterwochen",
    miscellaneous: "Sonstiges",
    beauty: "Schönheit",
    other: "Andere",
    videography: "Videografie",
    accommodation: "Unterkunft",
    stationery: "Papeterie",
    general: "Allgemein",
    "Lieu et Réception": "Ort und Empfang",
    "Animation et Photo": "Animation und Foto",
    "Tenues et Accessoires": "Kleidung und Accessoires",
    title: "Kategorien"
  },

  form: {
    title: "Titel",
    amount: "Betrag",
    category: "Kategorie",
    date: "Datum",
    vendor: "Dienstleister",
    notes: "Notizen",
    paid: "Bezahlt",
    errors: {
      titleRequired: "Titel ist erforderlich",
      amountRequired: "Betrag ist erforderlich",
      categoryRequired: "Kategorie ist erforderlich",
      amountPositive: "Betrag muss positiv sein"
    },
    description: "Beschreibung",
    dueDate: "Fälligkeitsdatum",
    status: "Status",
    submit: "Speichern",
    cancel: "Abbrechen",
    name: "Name"
  },

  filters: {
    all: "Alle",
    category: "Kategorie",
    status: "Status",
    vendor: "Dienstleister",
    categoryPlaceholder: "Kategorie auswählen",
    vendorPlaceholder: "Dienstleister auswählen",
    budgetsearch: "Ausgaben suchen",
    group: "Kategorie",
    groupPlaceholder: "Kategorie auswählen...",
    tableAssigned: "Zugewiesener Tisch",
    allCategories: "Alle Kategorien",
    allStatuses: "Alle Status",
    startDate: "Startdatum",
    endDate: "Enddatum",
    minAmount: "Min. Betrag (€)",
    maxAmount: "Max. Betrag (€)",
    resetFilters: "Filter zurücksetzen",
    search: "Ausgabe suchen",
    clear: "Filter löschen",
    apply: "Anwenden",
    previous: "Zurück",
    next: "Weiter",
  },

  status: {
    paid: "Bezahlt",
    unpaid: "Unbezahlt",
    pending: "Ausstehend",
    cancelled: "Storniert"
  },

  table: {
    title: "Titel",
    amount: "Betrag",
    category: "Kategorie",
    date: "Datum",
    status: "Status",
    description: "Beschreibung",
    actions: "Aktionen"
  },

  estimator: {
    title: "Budgetschätzer",
    guestCount: "Anzahl der Gäste",
    region: "Region",
    services: "Dienstleistungen",
    lieu: "Ort",
    traiteur: "Catering",
    photographie: "Fotografie",
    fleurs: "Blumen",
    musique: "Musik",
    tenues: "Kleidung",
    calculate: "Berechnen",
    estimatedBudget: "Geschätztes Budget",
    validateBudget: "Budget bestätigen",
    adjustAmount: "Betrag anpassen",
    modifyCriteria: "Kriterien ändern",
    next: "Weiter",
    previous: "Zurück",
    ileDeFrance: "Île-de-France (Paris)",
    paca: "PACA (Südfrankreich)",
    london: "London",
    otherUK: "Sonstiges UK",
    madrid: "Madrid",
    barcelona: "Barcelona",
    berlin: "Berlin",
    munich: "München",
    otherRegion: "Andere Region",
    style: "Welchen Hochzeitsstil wünschen Sie?",
  },

  noExpensesFiltered: {
    title: "Keine Ausgaben entsprechen Ihren Filtern",
    description: "Versuchen Sie, Ihre Suchkriterien anzupassen"
  },

  overrun: {
    title: "Budget überschritten",
    description: "Sie haben Ihr geplantes Budget überschritten"
  },

  success: {
    budgetUpdated: "Budget erfolgreich aktualisiert"
  },

  errors: {
    addExpense: "Fehler beim Hinzufügen der Ausgabe",
    deleteExpense: "Fehler beim Löschen der Ausgabe",
    updateExpense: "Fehler beim Aktualisieren der Ausgabe",
    loadExpenses: "Fehler beim Laden der Ausgaben",
    loadCategories: "Fehler beim Laden der Kategorien",
    loadWedding: "Fehler beim Laden der Hochzeitsdaten",
    loadTemplate: "Fehler beim Laden der Vorlage",
    updateBudget: "Fehler beim Aktualisieren des Budgets",
    noTemplateAvailable: "Keine Vorlage verfügbar",
    noWeddingFound: "Keine Hochzeit gefunden",
    loadData: "Fehler beim Laden der Daten",
    noUser: "Kein Benutzer angemeldet",
    missingWeddingId: "Hochzeits-ID fehlt"
  },

  pageExample: {
    title: "Budgetverwaltung",
    subtitle: "Planen und verfolgen Sie Ihre Hochzeitsausgaben",
    connectedAs: "Verbunden als",
    noAccess: "Kein Zugriff",
    overviewDescription: "Allgemeiner Überblick über Ihre Ausgaben und das verbleibende Budget",
    detailedExpenses: "Detaillierte Ausgaben",
    detailedExpensesDescription: "Vollständige Liste aller Ihrer Ausgaben",
    share: "Teilen",
    venues: {
      receptionVenue: "Empfangsort",
      chateauVersailles: "Schloss Versailles",
    },
    access: {
      readOnlyAccess: "Schreibgeschützter Zugriff - Kann nicht geändert werden",
      advancedConfig: "Erweiterte Konfiguration",
      advancedConfigDescription: "Budgeteinstellungen und Konfiguration",
      adminOnly: "Nur Admin",
      adminZone: "Admin-Bereich",
      adminZoneDescription: "Dieser Bereich enthält sensible Einstellungen, die nur für Administratoren zugänglich sind.",
      exportData: "Daten exportieren",
      resetBudget: "Budget zurücksetzen",
      permissionsInfo: "Informationen zu Ihren Berechtigungen",
      read: "Lesen",
      write: "Schreiben",
      delete: "Löschen",
      share: "Teilen",
    },
    description: "Dies ist eine Beispiel-Budgetseite mit Dummy-Daten",
    accessLevel: "Zugriffsebene",
    permissions: "Berechtigungen",
    venue: {
      title: "Ort",
      name: "Schloss der Rosen",
      capacity: "Kapazität: 150 Personen",
      location: "Provence, Frankreich",
      contact: "Kontakt: +33 1 23 45 67 89"
    },
    admin: {
      title: "Verwaltung",
      exportData: "Daten exportieren",
      importData: "Daten importieren",
      backupData: "Daten sichern",
      resetData: "Daten zurücksetzen"
    },
    status: {
      connected: "Verbunden",
      synchronized: "Synchronisiert",
      lastUpdate: "Letzte Aktualisierung: {{date}}"
    }
  },

  initialBudget: "Anfangsbudget",
  used: "verwendet",
  paymentStatus: "Zahlungsstatus",
  categoryProgress: "Fortschritt nach Kategorie",
  addExpenseLabel: "Ausgabe hinzufügen",

  expenses: {
    title: "Ausgaben",
    add: "Ausgabe hinzufügen",
    edit: "Ausgabe bearbeiten",
    name: "Name",
    amount: "Betrag",
    category: "Kategorie",
    date: "Datum",
    paid: "Bezahlt",
    unpaid: "Unbezahlt",
    notes: "Notizen",
    vendor: "Dienstleister",
    noExpenses: "Keine Ausgaben",
    total: "Gesamt",
    filter: "Filtern",
    search: "Suchen",
    delete: "Löschen",
    confirm: "Bestätigen"
  },

  modal: {
    title: "Ausgabe",
    edit: "Ausgabe bearbeiten",
    delete: "Ausgabe löschen",
    confirmDelete: "Sind Sie sicher, dass Sie diese Ausgabe löschen möchten?"
  },

  summary: {
    total: "Gesamt",
    spent: "Ausgegeben",
    remaining: "Verbleibend",
    overBudget: "Überschuss",
    currency: "€"
  },

  analytics: {
    title: "Budgetanalysen",
    insights: {
      title: "Erkenntnisse und Trends",
      topCategory: {
        title: "Hauptkategorie",
        description: "{{category}} macht {{percentage}}% Ihrer Ausgaben aus mit {{amount}}"
      },
      overBudget: {
        title: "Budget überschritten",
        description: "Sie haben Ihr Budget um {{percentage}}% überschritten ({{amount}})"
      },
      nearBudget: {
        title: "Budget fast erreicht",
        description: "Sie haben {{percentage}}% Ihres Budgets verbraucht. Es verbleiben {{remaining}}"
      },
      increasingTrend: {
        title: "Ausgaben steigen",
        description: "Ihre Ausgaben sind diesen Monat um {{amount}} gestiegen ({{month}})"
      },
      decreasingTrend: {
        title: "Ausgaben sinken",
        description: "Ihre Ausgaben sind diesen Monat um {{amount}} gesunken ({{month}})"
      }
    },
    charts: {
      categoryDistribution: "Verteilung nach Kategorie",
      monthlyTrend: "Monatstrend",
      monthlySpending: "Monatliche Ausgaben",
      cumulativeSpending: "Kumulierte Ausgaben",
      averagePerCategory: "Durchschnitt pro Kategorie",
      averageSpending: "Durchschnittliche Ausgaben"
    },
    details: {
      title: "Detaillierte Statistiken",
      transactions: "Transaktionen",
      average: "Durchschnitt"
    },
    overview: "Übersicht",
    byCategory: "Nach Kategorie",
    byMonth: "Nach Monat",
    trends: "Trends"
  },

  messages: {
    createSuccess: "Ausgabe erfolgreich hinzugefügt",
    updateSuccess: "Ausgabe erfolgreich aktualisiert",
    deleteSuccess: "Ausgabe erfolgreich gelöscht",
    deleteConfirm: "Sind Sie sicher, dass Sie diese Ausgabe löschen möchten?",
    error: "Ein Fehler ist aufgetreten",
    budgetCreated: "Budget erfolgreich erstellt",
    budgetUpdated: "Budget erfolgreich aktualisiert",
    budgetDeleted: "Budget erfolgreich gelöscht",
    expenseAdded: "Ausgabe erfolgreich hinzugefügt",
    expenseUpdated: "Ausgabe erfolgreich aktualisiert",
    expenseDeleted: "Ausgabe erfolgreich gelöscht",
    categoryAdded: "Kategorie erfolgreich hinzugefügt",
    categoryUpdated: "Kategorie erfolgreich aktualisiert",
    categoryDeleted: "Kategorie erfolgreich gelöscht"
  },
};
